import classNames from "classnames"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { forwardRef } from "react"
import { ValidationContextProvider } from "./ValidationContextProvider"
import styles from "./ValidationMessage.module.scss"
import type { ValidationMode } from "./ValidationMode"

export interface Props extends ComponentPropsWithoutRef<"div"> {
  validationMode?: ValidationMode[keyof ValidationMode];
}

export const ValidationContainer = forwardRef<HTMLDivElement, Props>(
  function ValidationContainer(props: Props, propRef: Ref<HTMLDivElement>) {
    const {
      validationMode,
      ...htmlDivProps
    } = props

    const className = classNames(
      props.className,
      styles.validationContainer,
    )

    return (
      <ValidationContextProvider validationMode={validationMode}>
        <div
          {...htmlDivProps}
          className={className}
          ref={propRef}
        />
      </ValidationContextProvider>
    )
  },
)
